<template>
	<div style="height: 1000px; width: 1000px; background-color: gray; padding: 100px 0 0 0;">
		<div v-show="test === 1" style="height: 100px; width: 100px; background-color: green">
		</div>
		<div v-show="test === 2" style="height: 100px; width: 100px; background-color: red">
		</div>
		<v-btn @click="click1">1</v-btn>
		<v-btn @click="click2">2</v-btn>
	</div>
</template>

<script>
export default {
	data () {
		return {
			test: 0
		}
	},
	methods: {
		click1 () {
			this.test = 1
		},
		click2 () {
			this.test = 2
		}
	}
}
</script>